import React from 'react';
import { useTranslation } from 'react-i18next';
import "./AddVenue.css";
import { useLocation } from "react-router-dom";

const CurrentStep = ({ step }) => {
  const { t } = useTranslation("addvenue");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const editVenue = searchParams.get('edit') === 'true';

  return (
    !editVenue && (
      <div className="Nav" style={{gap:"16px", flexWrap:"wrap"}}>
        <div className="Step">
          <div className={step === 1 ? "Active" : "Complete"}>
            1
          </div>
          <p>
            {t("basicInfo")}
          </p>
        </div>
        <div className="Step">
          <div className={step < 2 ? "nonActive" : step === 2 ? "Active" : "Complete"}>
            2
          </div>
          <p>
            {t("workingHours")}
          </p>
        </div>
        <div className="Step">
          <div className={step < 3 ? "nonActive" : step === 3 ? "Active" : "Complete"}>
            3
          </div>
          <p>
            {t("availability") || "Availability"}
          </p>
        </div>
        <div className="Step">
          <div className={step < 4 ? "nonActive" : step === 4 ? "Active" : "Complete"}>
            4
          </div>
          <p>
            {t("amenities")}
          </p>
        </div>
        <div className="Step">
          <div className={step < 5 ? "nonActive" : "Active"}>
            5
          </div>
          <p>
            {t("pricing")}
          </p>
        </div>
      </div>
    )
  );
};

export default CurrentStep;
